import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable } from 'rxjs';
// import { APIURL, CIAPIURL } from '../../app-routing.module';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NavigationTrackerService   {
  navigationDataArr:any=[]
  unsubscribe: any;
  x=0
  public appmod: string;

  constructor(private router: Router,protected http:HttpClient,private datePipe: DatePipe) {
  
   }



  // public listenForRouteChanges() {
  //   this.navigationDataArr=[]
  //     this.unsubscribe= this.router.events.subscribe(event => {
      
  //     console.log(event)
  //       if (event instanceof NavigationEnd) {
  //         console.log(event);
  //         let navigationData={}
  //         console.log(this.navigationDataArr)
  //         // navigationData.event=event
  //         if(this.navigationDataArr.length==0){
  //         console.log('Route changed:', event);
  //           navigationData['event']=event
  //           navigationData['start_time']=this.datePipe.transform(new Date(),'yyyy-MM-dd HH:mm:ss' )
  //           navigationData['end_time']=''
  //           navigationData['duration']=''
  //           this.navigationDataArr.push(navigationData)
  //       }else{
  //         console.log('Route changed:', event);
  //         navigationData['event']=event
  //         navigationData['start_time']=this.datePipe.transform(new Date(),'yyyy-MM-dd HH:mm:ss' )
  //           navigationData['end_time']=''
  //           navigationData['duration']=''
  //         this.navigationDataArr[this.navigationDataArr.length-1].end_time= navigationData['start_time']
  //         console.log("fsdgdfbg",this.navigationDataArr)
  //         this.navigationDataArr[this.navigationDataArr.length-1].duration=this.timeDiff( this.navigationDataArr[this.navigationDataArr.length-1]['start_time'],navigationData['start_time'])
  
  //         this.navigationDataArr.push(navigationData)
  //       }
  //       console.log("fsdgdfbg",this.navigationDataArr)
          
  //         // add your custom code here
  //       }
  //      });
     
      
  //   }
  //   public timeDiff(start_time,end_time){
  //     const duration = (new Date(end_time)).getTime() - (new Date(start_time)).getTime();
  //     console.log(duration,"duration");
      
  //     const hours = Math.floor(duration / 3600000);
  //     const minutes = Math.floor((duration - (hours * 3600000)) / 60000);
  //     const seconds = Math.floor((duration - (hours * 3600000) - (minutes * 60000)) / 1000);  
  //     const durationString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  //     console.log(durationString);
  //     return durationString
  //   }
  //   addNavigationData(){

  //   }
  //   public saveService(data: any, type?: string): Observable<any> {
  //     this.navigationDataArr=[]
  //     console.log(this.navigationDataArr)
  //     if (type != undefined && data.length>0){
  //        return this.http.post<any>(environment.SERVER + this.appmod, { "data": data },{ headers: { "Content-Type": "application/json" }, params: { type} });
  //     }else if(data.length>0){
  //       return this.http.post<any>(environment.SERVER + this.appmod, { "data": data },{ headers: { "Content-Type": "application/json" }, params: { type: "main" } });
  //   }
  // }

  getDetails(data?:any): Observable<any>{ 
    // return this.http.get('../../assets/details.json')
    
    this.appmod = "custom/details";
    return this.http.get<any>(environment.SERVER + this.appmod,{ headers: { "Content-Type": "application/json" }, params: { type: data } });
 
  }
  getReportData(){
    this.appmod = "getuserreports";
    return this.http.get<any>(environment.SERVER + this.appmod,{ headers: { "Content-Type": "application/json" }, params: { type: "main" } });
  }

  data_populatingreport(){
    this.appmod = "datapopulate";
    return this.http.get<any>(environment.SERVER + this.appmod,{ headers: { "Content-Type": "application/json" }, params: { type: "main" } });
  }
}
